/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Community_Links_MemberInputs */



/**
* | output |
* | --- |
* | "Your community links are visible to all VEKN members." |
*
* @param {Profile_Community_Links_MemberInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_community_links_member = /** @type {((inputs?: Profile_Community_Links_MemberInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Community_Links_MemberInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vos liens communautaires sont visibles par tous les membres VEKN.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tus enlaces comunitarios son visibles para todos los miembros VEKN.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Seus links da comunidade são visíveis para todos os membros VEKN.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I tuoi link della comunità sono visibili a tutti i membri VEKN.")
	return /** @type {LocalizedString} */ ("Your community links are visible to all VEKN members.")
});